export const SFC_LICENCE_TYPES = [
  { name: "type1", labelKey: "SFC Type 1" },
  { name: "type4", labelKey: "SFC Type 4" },
  { name: "type9", labelKey: "SFC Type 9" },
];

export const DEFAULT_SFC_LICENCES = {
  type1: false,
  type4: false,
  type9: false,
};
